import { render, staticRenderFns } from "./Apostar.vue?vue&type=template&id=22d27535"
import script from "./Apostar.vue?vue&type=script&lang=js"
export * from "./Apostar.vue?vue&type=script&lang=js"
import style0 from "./Apostar.vue?vue&type=style&index=0&id=22d27535&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports